import { AxiosResponse } from "axios";
import { ResponseDTO } from "types";
import { BookingDTO } from "types/DTOs/booking/booking.dto";
import { get, post } from "utils";

const baseUrl = `${process.env.REACT_APP_API_URL}/booking`;

export const createBooking = async (
  scheduleId: string,
  serviceId: string
): Promise<AxiosResponse<ResponseDTO<BookingDTO>>> => {
  return post(baseUrl + "/", { scheduleId, serviceId });
};

export const processPayment = async (
  bookingId: string,
  paymentKey: string,
  orderId: string,
  amount: number
): Promise<AxiosResponse<ResponseDTO<BookingDTO>>> => {
  return post(`${baseUrl}/${bookingId}/pay`, { paymentKey, orderId, amount });
};

export const getMyBookings = async (): Promise<
  AxiosResponse<ResponseDTO<BookingDTO[]>>
> => {
  return get(`${baseUrl}/my`);
};

export const getHostBookings = async (): Promise<
  AxiosResponse<ResponseDTO<BookingDTO[]>>
> => {
  return get(`${baseUrl}/host`);
};

export const completeBooking = async (
  bookingId: string
): Promise<AxiosResponse<ResponseDTO<BookingDTO>>> => {
  return post(`${baseUrl}/${bookingId}/complete`, {});
};

export const cancelBooking = async (
  bookingId: string,
  cancelReason?: string
): Promise<AxiosResponse<ResponseDTO<BookingDTO>>> => {
  return post(`${baseUrl}/${bookingId}/cancel`, { cancelReason });
};
